import { list, third, listItem, selected } from 'components/CameraModelSelector/style'
import cameraStyle from 'components/CameraModelSelector/ManufacturerList/style'
import { COLORS } from 'helpers/globals'

export default {
  container: {
    ...third
  },
  list: {
    ...list,
    borderLeft: `1px solid ${COLORS.quaternary}`
  },
  listItemOdd: {
    ...listItem,
    background: 'white !important'
  },
  listItemEven: {
    ...listItem,
    background: `${COLORS.tertiary} !important`
  },
  selected: {
    ...selected,
    cursor: 'pointer'
  },
  manufacturerName: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    flex: 1
  },
  clock: cameraStyle.clock,
  star: cameraStyle.star
}



// WEBPACK FOOTER //
// ./src/components/DoorControllerModelSelector/ManufacturerList/style.js